import React, { useEffect, useState } from "react";
import axios from "axios";
import * as Constants from "../../constants/urls";
import { useCookies } from "react-cookie";
import { Link } from "react-router-dom";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import moment from "moment-jalaali";
import Pagination from "react-js-pagination";
import Loading from "../Loading/Loading";
import SmsSendModal from "./SmsSendModal";
 
export default function SmsSend() {
  const [data, setData] = useState(undefined);
  const [modal, setModal] = useState(false);
  const [viewItem, setViewItem] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [cookies, setCookie, removeCookie] = useCookies();
  const [filters, setFilters] = useState([
    {
      key: "id",
      value: null,
    },
    {
      key: "ip",
      value: null,
    },
    {
      key: "template",
      value: null,
    },
    {
      key: "receiver",
      value: null,
    },
    {
      key: "code",
      value: null,
    },
  ]);
  useEffect(() => {
    getData();
  }, []);
  function getData(page = 1) {
    setLoading(true);
    let filterUrl = "&";
    filters.map((item) => {
      if (item.value != null) filterUrl += `filter[${item.key}]=${item.value}&`;
    });

    const url =
      Constants.apiUrl +
      "/api/sms/dataTable?page=" +
      page +
      filterUrl;
    axios
      .get(url, {
        headers: {
          Authorization: "Bearer " + cookies.user_server_token,
        },
      })
      .then((r) => {
        setData(r.data.data);
        setLoading(false);

        console.log(r);
      })
      .catch((e) => {
        setLoading(false);
      });
  }

  useEffect(() => {
    getData(1);
  }, [filters]);

  function filterHandle(e) {
    let key = e.target.name;
    let value = e.target.value;
    let oldValue = "";
    const newFilter = filters.map((obj) => {
      if (obj.key == key) {
        oldValue = obj.value;
        return { ...obj, value: value };
      }
      return obj;
    });
    if (oldValue != value) setFilters(newFilter);
  }

  return (
    <>
      <Breadcrumb title={"مدیریت پیامک های ارسال شده"} />
      {loading && <Loading />}
      {modal && viewItem && <SmsSendModal item={viewItem} close={()=>{setModal(false);}}/>}

      <div className="table-responsive mt-5 mb-5">
        <table className="table table-striped table-hover">
          <thead>
            <tr>
              <td>شناسه</td>
              <td> ip </td>
              <td> الگو </td>
              <td> شماره موبایل </td>
              <td> تاریخ ارسال </td>
              <td> </td>
            </tr>
            <tr className={" "}>
              <th>
                <input
                  name={"id"}
                  onBlur={filterHandle}
                  type={"text"}
                  className={"form-control text-center"}
                />
              </th>
              <th>
                <input
                  name={"ip"}
                  onBlur={filterHandle}
                  type={"text"}
                  className={"form-control text-center"}
                />
              </th>
              <th>
                <input
                  name={"template"}
                  onBlur={filterHandle}
                  type={"text"}
                  className={"form-control text-center"}
                />
              </th>
              <th>
                <input
                  name={"receiver"}
                  onBlur={filterHandle}
                  type={"text"}
                  className={"form-control text-center"}
                />
              </th>
              <th>
                
              </th>
              <th></th>
            </tr>
          </thead>
          {data &&
            data.data &&
            data.data.map((item) => {
              return (
                <tr>
                  <td>{item.id}</td>
                  <td>{item.ip}</td>
                  <td>{item?.sms_template?.name}</td>
                  <td>{item.receiver}</td>
                   <td>
                    {item.created_at && moment(item.created_at ).format("jYYYY/jMM/jDD")}     
                     
                  </td>
                  <td>
                    <button
                      className="btn btn-warning"
                      onClick={() => {
                        setViewItem(item);
                        setModal(true);
                      }}
                    >
                      مشاهده جزییات
                    </button>
                  </td>
                </tr>
              );
            })}
        </table>
        {data && (
          <div className="pager Page navigation example">
            <Pagination
              totalItemsCount={data.total}
              activePage={data.current_page}
              itemsCountPerPage={data.per_page}
              onChange={(number) => {
                getData(number);
              }}
              itemClass="page-item"
              linkClass="page-link"
              firstPageText="اولین صفحه"
              lastPageText="آخرین صفحه"
              nextPageText="بعدی"
              prevPageText="قبلی"
              activeClass="pageactive"
            />
          </div>
        )}
      </div>
    </>
  );
}
